var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-controls"
  }, [_vm.showToolbar ? _c('TableToolbar', {
    ref: "toolbar",
    attrs: {
      "search-value": _vm.searchValue,
      "search-placeholder": _vm.resolvedSearchPlaceholder,
      "has-search": _vm.hasSearchFilter,
      "has-filters": _vm.hasNonSearchFilters && !_vm.forceFiltersPanelOpen,
      "has-active-filters": _vm.hasActiveNonSearchFilters,
      "filters-panel-open": _vm.effectiveFiltersPanelOpen,
      "views-scope": _vm.toolbarViewsScope,
      "views-exclude-keys": _vm.viewsExcludeKeys,
      "filters": _vm.filters,
      "views-menu-open": _vm.viewsMenuOpen,
      "has-active-view": !!_vm.activeViewLabel,
      "columns-menu-open": _vm.columnsMenuOpen,
      "enable-column-management": _vm.enableColumnManagement,
      "columns": _vm.columns,
      "column-state": _vm.columnState,
      "columns-customized": _vm.columnsCustomized,
      "search-product-completion": _vm.searchProductCompletion,
      "product-search-params": _vm.productSearchParams,
      "exclude-product-ids": _vm.excludeProductIds,
      "autofocus": _vm.shouldAutofocusSearch
    },
    on: {
      "search-change": _vm.onSearchChange,
      "product-select": _vm.onProductSelect,
      "toggle-filters": _vm.toggleFiltersPanel,
      "toggle-views": function toggleViews($event) {
        _vm.viewsMenuOpen = !_vm.viewsMenuOpen;
      },
      "toggle-columns": function toggleColumns($event) {
        _vm.columnsMenuOpen = !_vm.columnsMenuOpen;
      },
      "view-apply": _vm.onViewApply,
      "view-reset": _vm.onViewReset,
      "active-view-change": _vm.onActiveViewChange,
      "columns-change": _vm.onColumnsChange,
      "columns-reset": _vm.onColumnsReset
    }
  }) : _vm._e(), _vm.showViewsBar && _vm.viewsScope && _vm.hasAnyActiveFilters ? _c('TableViewsBar', {
    ref: "viewsBar",
    attrs: {
      "views-scope": _vm.viewsScope,
      "filters": _vm.filters,
      "views-exclude-keys": _vm.viewsExcludeKeys,
      "show-filter-actions": _vm.effectiveFiltersPanelOpen
    },
    on: {
      "apply": _vm.onViewApply,
      "reset": _vm.onViewReset,
      "active-view-change": _vm.onActiveViewChange
    }
  }) : _vm._e(), _vm.hasNonSearchFilters && _vm.showFiltersBar ? _c('TableFiltersBar', {
    attrs: {
      "filters": _vm.filters,
      "full-filters-conf": _vm.fullFiltersConf,
      "panel-open": _vm.effectiveFiltersPanelOpen,
      "active-view-label": _vm.activeViewLabel,
      "quick-filter-count": _vm.quickFilterCount
    },
    on: {
      "filter-change": _vm.onFilterPillChange,
      "reset": _vm.resetFilters,
      "clear-view": _vm.onViewReset,
      "remove-product": _vm.onRemoveProduct
    }
  }) : _vm._e(), _c('Filters', {
    ref: "filtersEngine",
    attrs: {
      "headless": "",
      "filters-conf": _vm.filtersConf,
      "filters": _vm.filters,
      "enable-ordering": _vm.enableOrdering,
      "exclude-from-ordering": _vm.excludeFromOrdering
    },
    on: {
      "on-filters-change": function onFiltersChange($event) {
        return _vm.$emit('on-filters-change', $event);
      },
      "conf-updated": function confUpdated($event) {
        _vm.fullFiltersConf = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }